import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { STORE_BACKEND_URL } from '../../app.config';
import { GetCategoryProductsRequest } from '../model/get-category-products.request';
import { GetCategoryProductsResponse } from '../model/get-category-products.response';

@Injectable({
    providedIn: 'root',
})
export class GetCategoryProductsUseCase extends UseCase<GetCategoryProductsRequest, Observable<GetCategoryProductsResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>(STORE_BACKEND_URL);
    private _getCategoryProductsUrl = '/store/getCategoryProducts';

    constructor(_logService: LogService, protected override _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: GetCategoryProductsRequest | void
    ): Observable<GetCategoryProductsResponse> | void {
        return this._apiRequestService.sendRequest<GetCategoryProductsRequest, GetCategoryProductsResponse>(
            this._storeBaseUrl,
            request as GetCategoryProductsRequest,
            true,
            this._getCategoryProductsUrl
        );
    }
}
